var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2317 4.66168C23.6472 3.26552 25.9266 3.28124 27.3227 4.69679C30.1775 7.59119 31.9844 11.5824 31.9844 15.9922C31.9844 17.9804 30.3726 19.5922 28.3844 19.5922C26.3961 19.5922 24.7844 17.9804 24.7844 15.9922C24.7844 13.5864 23.803 11.3815 22.1966 9.75273C20.8004 8.33718 20.8162 6.05784 22.2317 4.66168Z",
    fill: "url(#paint0_linear_0_2085)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3921 3.6C12.3921 1.61177 14.0039 0 15.9921 0C20.4019 0 24.3931 1.80687 27.2875 4.66163C28.7031 6.05779 28.7188 8.33712 27.3226 9.75268C25.9265 11.1682 23.6471 11.1839 22.2316 9.78779C20.6028 8.18136 18.3979 7.2 15.9921 7.2C14.0039 7.2 12.3921 5.58823 12.3921 3.6Z",
    fill: "url(#paint1_linear_0_2085)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.9922C0 7.15726 7.15726 0 15.9922 0C17.9804 0 19.5922 1.61177 19.5922 3.6C19.5922 5.58823 17.9804 7.2 15.9922 7.2C11.1337 7.2 7.2 11.1337 7.2 15.9922C7.2 18.398 8.18136 20.6029 9.78779 22.2316C11.1839 23.6472 11.1682 25.9265 9.75268 27.3227C8.33712 28.7188 6.05779 28.7031 4.66163 27.2876C1.80687 24.3932 0 20.402 0 15.9922Z",
    fill: "url(#paint2_linear_0_2085)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66143 22.2317C6.05759 20.8162 8.33693 20.8004 9.75248 22.1966C11.3812 23.803 13.5861 24.7844 15.992 24.7844C17.9802 24.7844 19.592 26.3962 19.592 28.3844C19.592 30.3726 17.9802 31.9844 15.992 31.9844C11.5821 31.9844 7.59095 30.1775 4.69654 27.3228C3.28099 25.9266 3.26527 23.6473 4.66143 22.2317Z",
    fill: "url(#paint3_linear_0_2085)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3842 12.3922C30.3725 12.3922 31.9842 14.004 31.9842 15.9922C31.9842 24.8271 24.827 31.9844 15.9921 31.9844C14.0039 31.9844 12.3921 30.3726 12.3921 28.3844C12.3921 26.3961 14.0039 24.7844 15.9921 24.7844C20.8505 24.7844 24.7842 20.8507 24.7842 15.9922C24.7842 14.004 26.396 12.3922 28.3842 12.3922Z",
    fill: "url(#paint4_linear_0_2085)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3847 12.3922C30.3729 12.3922 31.9847 14.004 31.9847 15.9922V28.3844C31.9847 30.3726 30.3729 31.9844 28.3847 31.9844C26.3964 31.9844 24.7847 30.3726 24.7847 28.3844V15.9922C24.7847 14.004 26.3964 12.3922 28.3847 12.3922Z",
    fill: "url(#paint5_linear_0_2085)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2085)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2322 4.66168C23.6477 3.26552 25.9271 3.28124 27.3232 4.69679C30.178 7.59119 31.9849 11.5824 31.9849 15.9922C31.9849 17.9804 30.3731 19.5922 28.3849 19.5922C26.3966 19.5922 24.7849 17.9804 24.7849 15.9922C24.7849 13.5864 23.8035 11.3815 22.1971 9.75273C20.8009 8.33718 20.8166 6.05784 22.2322 4.66168Z",
    fill: "url(#paint6_linear_0_2085)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_2085",
    x1: 26.3999,
    y1: 9.60005,
    x2: 28.7999,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E22CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_2085",
    x1: 26.7999,
    y1: 9.4,
    x2: 17.7999,
    y2: 3.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_2085",
    x1: 3.6,
    y1: 14,
    x2: 5.4,
    y2: 24.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22C55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15803D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_2085",
    x1: 4.7999,
    y1: 22.2,
    x2: 14.3999,
    y2: 29.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94A3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958345,
    stopColor: "#64748B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64748B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_2085",
    x1: 28.3999,
    y1: 22.1726,
    x2: 22.1882,
    y2: 28.3844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D97706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_2085",
    x1: 29.2003,
    y1: 54.4,
    x2: 30.6257,
    y2: 54.2562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_2085",
    x1: 26.4004,
    y1: 9.60005,
    x2: 28.8004,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E22CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.2,
    height: 8,
    fill: "white",
    transform: "translate(24.8003 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllure);
export default __webpack_public_path__ + "static/media/allure.6aea2109feb9f4d8d92ad4e8d12c8595.svg";
export { ForwardRef as ReactComponent };